import * as React from 'react';
import { TR } from 'src/TextRes';
import { ServerResponse } from '../../api';
import './NetworkOverlay.css';

interface INetworkOverlayProps {
    loading: boolean;
    forceLoading?: boolean;
    hideContentWhileLoading?: boolean;
    serverResponse?: ServerResponse;
}

export default class NetworkOverlay extends React.PureComponent<INetworkOverlayProps> {
    public render() {
        const forceLoading = this.props.forceLoading ? this.props.forceLoading : false;

        const notLoggedIn = this.props.serverResponse && this.props.serverResponse.Error === 'unauthorized';

        const connectionError = this.props.serverResponse && this.props.serverResponse.Error === 'communication_error';

        if (!forceLoading && !notLoggedIn && !connectionError && !this.props.loading) {
            return this.props.children;
        }

        return (
            <div className="networkOverlay">
                <div className="lds-dual-ring" />
                {!this.props.hideContentWhileLoading && this.props.children}
                {notLoggedIn && (
                    <div className="message">
                        Sie sind nicht eingeloggt <br />
                        <a href="/">Zum Login</a>
                    </div>
                )}
                {connectionError && <div className="message">{TR.networkOverlay_network_error} </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/networkOverlay/NetworkOverlay.tsx